export const TableSettingsTestIds = {
  tableSettingsButton: 'table_settings_button',
  columnSettingsMenu: 'column_settings_menu'
} as const;
